import { type FC } from 'react';

import { useBooleanFlags } from '@/core/flags/flags.hooks';
import { BillieBannerV2 } from '@/customerFinanceOperations/components/BillieBannerV2/BillieBannerV2';
import { FeatureFlags } from '@/customerFinanceOperations/constants/FeatureFlags';
import { Span } from '@/domains/core/tamagoshiTailwind/components/Typography/Typography';
import { twMerge } from '@/domains/core/tamagoshiTailwind/util/twMerge';

import { useIsBillieActive } from '../../Payment/components/PaymentMethods/Billie/hooks/useIsBillieActive';
import { billieBannerDescription } from './translations';

interface Props {
  className?: string;
}

export const BillieBanner: FC<Props> = ({ className }) => {
  const showBillieBanner = useIsBillieActive();
  const [buyNowPayLaterV2] = useBooleanFlags([
    FeatureFlags.BUY_NOW_PAY_LATER_V2,
  ]);

  if (!showBillieBanner) {
    return null;
  }

  if (buyNowPayLaterV2) {
    return <BillieBannerV2 className={className} />;
  }

  return (
    <Span
      scale="body2"
      className={twMerge(
        'flex justify-center whitespace-break-spaces text-foundation-primary',
        className,
      )}
      data-testid="billie-banner"
    >
      {billieBannerDescription.format({
        bold: (...chunks) => (
          <Span weight="bold" scale="body2" key="bold">
            {chunks}
          </Span>
        ),
      })}
    </Span>
  );
};

BillieBanner.displayName = 'BillieBanner';
